import { useApi, useMount } from "hooks";
import React, { useCallback } from "react";
import lang from "translations";
import SectionForm from "../section-form/section-form";
import { createSection } from "apis";
import { sectionRequest } from "mappers";
import { mapResourcesToZone } from "apis/resource.api";

const CreateSection = () => {
  const { request, loading: submitting } = useApi({
    api: createSection,
    handleOwnError: { badrequest: true },
    paramsMapper: sectionRequest,
  });

  useMount(() => {
    // analytics or tracking if needed
  });

  const submitForm = useCallback(
    async (params) => {
      try {
        const res = await request(params);
        // After create, call resource mapping API
        const sectionId = res.data?.sectionId || res.data?.zoneId;
        if (sectionId) {
          await mapResourcesToZone({
            venueId: params.venueId,
            zoneId: sectionId,
            resourceIds: params.resourceIds || [],
          });
        }
        return {
          response: res,
          message: lang.populate(lang.sectionCreated, [params.name]),
        };
      } catch (e) {
        throw e;
      }
    },
    [request]
  );

  return <SectionForm submit={submitForm} title={lang.createSection} submitting={submitting} />;
};

export default CreateSection;